<div
    class="mp-profile-intro-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="trezo-card-header d-flex align-items-center justify-content-between">
        <div class="trezo-card-title">
            <h5 class="mb-0">
                Profile Intro
            </h5>
        </div>
    </div>
    <div class="trezo-card-content">
        <div class="user d-flex align-items-center">
            <div class="image">
                <img src="images/admin.png" class="rounded-circle" alt="admin-image">
            </div>
            <div class="title">
                <span class="d-block text-black fw-semibold">
                    Olivia John
                </span>
                <span class="d-block">
                    Marketing Manager
                </span>
            </div>
        </div>
        <span class="sub-title d-block fw-semibold text-black">
            About Me
        </span>
        <p>
            Molestie tincidunt ut consequat a urna tortor. Vitae velit ac nisl velit mauris placerat nisi placerat. Pellentesque viverra lorem malesuada nunc tristique sapien. Imperdiet sit hendrerit tincidunt bibendum donec adipiscing.
        </p>
        <h6 class="fw-semibold">
            Social Profile
        </h6>
        <div class="socials-link">
            <a href="https://www.facebook.com/" target="_blank" class="facebook d-inline-block text-center position-relative rounded-circle">
                <i class="ri-facebook-fill"></i>
            </a>
            <a href="https://twitter.com/" target="_blank" class="x d-inline-block text-center position-relative rounded-circle">
                <i class="ri-twitter-x-fill"></i>
            </a>
            <a href="https://www.linkedin.com/" target="_blank" class="linkedin d-inline-block text-center position-relative rounded-circle">
                <i class="ri-linkedin-fill"></i>
            </a>
            <a href="mailto:micheal@gmail.com" class="mail d-inline-block text-center position-relative rounded-circle">
                <i class="ri-mail-fill"></i>
            </a>
        </div>
    </div>
</div>